import PropTypes from "prop-types";

export default function LoaderIconAndroid(props) {
  LoaderIconAndroid.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
  };

  let { height, width } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Combined Shape</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M6.5,15 C8.43299662,15 10,16.5670034 10,18.5 C10,20.4329966 8.43299662,22 6.5,22 C4.56700338,22 3,20.4329966 3,18.5 C3,16.5670034 4.56700338,15 6.5,15 Z M18.5,12 C20.4329966,12 22,13.5670034 22,15.5 C22,17.4329966 20.4329966,19 18.5,19 C16.5670034,19 15,17.4329966 15,15.5 C15,13.5670034 16.5670034,12 18.5,12 Z M3.5,3 C5.43299662,3 7,4.56700338 7,6.5 C7,8.43299662 5.43299662,10 3.5,10 C1.56700338,10 0,8.43299662 0,6.5 C0,4.56700338 1.56700338,3 3.5,3 Z M15.5,0 C17.4329966,0 19,1.56700338 19,3.5 C19,5.43299662 17.4329966,7 15.5,7 C13.5670034,7 12,5.43299662 12,3.5 C12,1.56700338 13.5670034,0 15.5,0 Z"
          id="Combined-Shape"
          fill="#2140A6"
        ></path>
      </g>
    </svg>
  );
}
